import React from 'react';

const Sponsors = ({ sponsors, sponsorsRef }) => {
  const handleClick = (e, websiteUrl) => {
     if (!websiteUrl) e.preventDefault();
  };

  return (
    <div className='mt-32' ref={sponsorsRef}>
      <label className='t1 w3 mb-32'>Sponsors</label>
      <div className='sponsors card-list'>
        {sponsors.map((sponsor) => {
          const { id, asset, websiteUrl, industry, name } = sponsor;

          return (
            <a href={`https://${websiteUrl}`} className='text-black' key={id} target={'_blank'} onClick={(e) => handleClick(e, websiteUrl)}>
              <div className='sponsor-card'>
                <div className='display-flex border-bottom logo-box'>
                  <img src={asset} alt={name} />
                </div>
                <div className='sponsor-info'>
                  <p className='t2 w3'>{name}</p>
                  <p>{industry}</p>
                </div>
              </div>
            </a>
          );
        })
        }
      </div>
    </div>
  );
};

export default Sponsors;
